import { DynamicConsistentCharacterModal } from './popups/dynamic'

import { initialPopupConfig } from '@/contexts/SiteSpecificContext/popups/helpers'

export const promotionPopupsConfig = {
  consistentCharacterModalV3: initialPopupConfig({
    priority: 500,
    component: DynamicConsistentCharacterModal,
    cache: {
      type: 'interval',
      timeout: 1,
      upperLimit: 2,
    },
  }),
}
